export type SchoolAiConfig = {
  headerIconImagePath: string;
  headerIconImageUrl: string;
  headerTitle: string;
  pageTitle: string;
  updatedAt: number;
  canViewUsageData?: boolean; //子スクール用データ: 会話データ出力画面において、使用料・料金周りを見れるか(親スクール OR 管理人が設定する)
  // ホーム画面のアプリ一覧の上に入力欄を開いておくアプリ（prompt の doc パス）。先生と生徒で別に選ぶ。
  // 会話はメッセージを送ったときに始まる。空・未設定は開かない（UI設定で管理者以上の先生が選ぶ）
  homeLaunchPromptPathForTutors?: string;
  homeLaunchPromptPathForStudents?: string;
};

export function convertToSchoolAiConfig(
  schoolConfigData: SchoolAiConfig | undefined
): SchoolAiConfig {
  if (!schoolConfigData) {
    return {
      headerIconImagePath: "",
      headerIconImageUrl: "",
      headerTitle: "",
      pageTitle: "",
      updatedAt: 0,
      canViewUsageData: true
    };
  } else {
    return {
      headerIconImagePath: schoolConfigData.headerIconImagePath ?? "",
      headerIconImageUrl: schoolConfigData.headerIconImageUrl ?? "",
      headerTitle: schoolConfigData.headerTitle ?? "",
      pageTitle: schoolConfigData.pageTitle ?? "",
      updatedAt: schoolConfigData.updatedAt ?? 0,
      canViewUsageData: schoolConfigData.canViewUsageData ?? true,
      ...(schoolConfigData.homeLaunchPromptPathForTutors
        ? {
            homeLaunchPromptPathForTutors:
              schoolConfigData.homeLaunchPromptPathForTutors
          }
        : {}),
      ...(schoolConfigData.homeLaunchPromptPathForStudents
        ? {
            homeLaunchPromptPathForStudents:
              schoolConfigData.homeLaunchPromptPathForStudents
          }
        : {})
    };
  }
}
